var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaskLine = function SvgTaskLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.6 3.893v16.214a.9.9 0 0 1-.894.893H5.294a.894.894 0 0 1-.894-.893V3.893A.9.9 0 0 1 5.294 3h14.412c.494 0 .894.4.894.893m-1.8.907H6.2v14.4h12.6zm-6.936 8.209 3.818-3.818 1.273 1.273-5.091 5.091-3.501-3.501 1.273-1.273z"
  })));
};
export default SvgTaskLine;